import { Component, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { GetWorkflowForViewDto, WorkflowListDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    selector: 'viewRequesrFlowModal',
    templateUrl: './view-requesrFlow-modal.component.html'
})
export class ViewRequesrFlowModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    item: GetWorkflowForViewDto;


    constructor(
        injector: Injector
    ) {
        super(injector);
        this.item = new GetWorkflowForViewDto();
        this.item.workflow = new WorkflowListDto();
    }

    show(item: GetWorkflowForViewDto): void {
        this.item = item;
        this.active = true;
        this.modal.show();
     
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
    addSpacesBeforeCapitalLetters(input: string): string {
        // Use regular expression to add space before each capital letter
        return input!=undefined?input.replace(/([A-Z])/g, ' $1'):input;
     }
    


}


